// The SPA's bootstrap pair: what it reads before anybody signs in, and where a signed-in
// caller may act.

import { api } from '../client'
import type { components } from '../schema'

export type InitResponse = components['schemas']['InitResponse']
export type Access = components['schemas']['Access']
export type OrgScope = components['schemas']['OrgScope']
/** Why an organization's public side is withheld: an empty wallet, or a never-paid wallet's day spent. */
export type PublicSideOfflineReason = components['schemas']['PublicSideOfflineReason']
export type MembershipSummary = components['schemas']['MembershipSummary']

/** The platform, its enabled public flags and its identity providers. Anonymous. */
export function getInit(signal?: AbortSignal): Promise<InitResponse> {
  return api.get<InitResponse>('/init', undefined, signal)
}

/**
 * Every membership, and the scope the active organization resolves to — `org` is `null` when
 * no organization is active and the caller holds several, or none.
 */
export function getAccess(signal?: AbortSignal): Promise<Access> {
  return api.get<Access>('/access', undefined, signal)
}
